import Auth from '../modules/Authentication'
import { apiUrl } from '../variables'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const RatingApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}rating`, { headers }).then(handleErrors).then(handleResponse)
  },
  read: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}rating/${key}`, { headers }).then(handleErrors).then(handleResponse)
  },
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}rating/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}rating/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}rating/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  operation: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}rating/action`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
